import React from 'react';

import {Row, Col, Badge, Button} from 'react-bootstrap';

import InRowHeadingContent from '../../UI/InRowHeadingContent';

export default function StepTwo({data, handlers}) {
  const totalPrice = data.serviceData.sessionPrice * data.bookedDates.length;
  const datesUIMaker = ()=>{
    return (
        <>
            {
                data.bookedDates.map((d)=>{
                    return (
                        <Badge className="me-2">
                            {d}
                        </Badge>
                    )
                })
            }
        </>
    );
  }
  return (
    <div>
        <Row>
            <Col md="6">
                <h5>Summary:</h5>
                <hr/>
                <InRowHeadingContent heading="Activity:" content={data.serviceData.title} className="mb-2"/>
                <InRowHeadingContent heading="Child Name:" content={data.childName} className="mb-2"/>
                <InRowHeadingContent heading="Booking Dates:" content={datesUIMaker()}/>
            </Col>
            <Col md="6">
                <h5 className='mt-md-0 mt-4'>Total Bill:</h5>
                <hr/>
                <InRowHeadingContent heading="Per Session Cost:" content={'$'+data.serviceData.sessionPrice} className="mb-2"/>
                <InRowHeadingContent heading="Booking Days:" content={data.bookedDates.length} className="mb-2"/>
                <InRowHeadingContent heading="Total Bill =" content={'$'+totalPrice} className="mb-2"/>
            </Col>
        </Row>
        <div className='form-foot d-flex justify-content-end'>
            <Button variant="secondary" size="md" type="button" onClick={handlers.handleClose}>
                Close
            </Button>
            <Button variant="primary" size="md" type="submit" className="ms-3" onClick={() => handlers.goToNextStep(data.bookingData)}>
                Book Now
            </Button>
        </div>
    </div>
  )
}
